import React from 'react'

import dayjs from 'dayjs'
import { Avatar } from 'antd'
import Icon from '@forwardflow/ui/Icons'

interface MessageItemProps {
   item: any
}

export const CallLeadItem: React.FC<MessageItemProps> = ({ item }) => {
   return (
      <div className="flex items-end justify-end gap-x-2 ">
         <div className="flex bg-[#594180] py-4 pl-4 pr-8 max-w-[450px] rounded-3xl rounded-br-none gap-x-4">
            <div className="w-8 h-8 rounded-full bg-black/30 flexc shrink-0">
               <Icon name="CallRing" />
            </div>
            <div className="flex flex-col items-start justify-between gap-y-1">
               <p className="text-[14px] font-medium">{item?.content}</p>
               <p className="text-[10px] text-white/70 w-full text-right">
                  {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
               </p>
            </div>
         </div>
         <Avatar src={item.assistant.avatar} className="w-10 h-10">
            {item?.assistant?.name?.slice(0, 1) || 'A'}
         </Avatar>
      </div>
   )
}
